import _ from "lodash";
import React, { createRef } from "react";
import classes from "./SubmissionItem.scss";
import UIBaseComponent from "UIComponents/UIBaseComponent";
import I18nHOC from "UIComponents/I18nHOC";
import NotAddedEmptyView from "UIComponents/NotAddedEmptyView";
import FullScreenLoader from "UIComponents/FullScreenLoader";
import { getUserInfo } from "Login/modules/LoginModule/LoginUtils";
import { compose } from "lib/apolloClient";
import { AttachmentList, CreateDropDown } from "Attachment";
import { Button } from "@toddle-edu/ds-web";
import { ICONS } from "Constants";
import { colors } from "@toddle-edu/ds-theme";
import SimilarityIndexComponent from "AppComponents/SimilarityIndexComponent";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import {
  getCurrentProjectGroupDetails,
  getAutoCheckSimilaritySettingName,
  createAttachmentForProjects,
} from "Projects/modules/ProjectModules";
import classNames from "classnames";
import { createAttachment } from "modules/Services";
import { getSettingValue } from "modules/PermissionModule";
import { isAttachmentLocked } from "Utils/AttachmentHelpers";
import {
  STUDENT,
  ENTITY_LOCKED_STATE,
  ENTITY_TO_BE_LOCKED_STATE,
  ENTITY_LOCKING_MINUTES,
  CURRICULUM_TYPE_DP,
} from "Constants/stringConstants";
import { getUserType } from "modules/CommonSelectors";
import moment from "moment";
import CreateDropDownWithAudioRecorder from "./components/CreateDropDownWithAudioRecorder";
import {
  DeviceDesktopOutlined,
  GoogleDriveColored,
  OneDriveColored,
  LinkOutlined,
} from "@toddle-edu/ds-icons";

const DROP_DOWN_OPTIONS = [
  {
    key: "upload_device",
    label: "upload_device",
    icon: "DeviceDesktopOutlined",
  },
  {
    key: "add_google_drive",
    label: "add_google_drive",
    icon: "GoogleDriveColored",
  },
  { key: "add_one_drive", label: "add_one_drive", icon: "OneDriveColored" },
];

const ICONS_MAP = {
  DeviceDesktopOutlined: <DeviceDesktopOutlined />,
  GoogleDriveColored: <GoogleDriveColored />,
  OneDriveColored: <OneDriveColored />,
  LinkOutlined: <LinkOutlined />,
};

const styles = {
  attachmentContainerStyle: {
    gridGap: "24px",
  },
  attachmentContainerStyleV2: {
    gridGap: "16px",
  },
  horizontalCardStyle: {
    borderRadius: "8px",
    cursor: "default",
    width: "288px",
  },
  horizontalCardStyleV2: {
    width: "326px",
  },
  buttonDropdownParentContainerStyle: {
    width: "max-content",
  },
};

// Currently this component is used in projects, For making it generalized component,
// we need change projectGroupId, projectGroupType, projectGroupSubType to entityId, entityType, entitySubType
class SubmissionItem extends UIBaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      showMoreAttachments: false,
      showFullScreenLoader: false,
    };
    this.autoCheckSimilarityRef = createRef();
  }

  componentDidMount = () => {
    const { showSingleAttachment } = this.props;
    this.setState({ showMoreAttachments: showSingleAttachment });
  };

  updateInputFieldLocally = (params, extraParams) => {
    const { name, value, updateInputField } = this.props;

    if (_.isEmpty(params[name])) {
      params[name] = _.difference(value, [_.head(value)]);
    }

    updateInputField(params, extraParams);
  };

  getMutationForCreateAttachment = () => {
    switch (this.props.sourceFrom) {
      case "PROJECTS": {
        return this.props.createAttachmentForProjects;
      }
      default: {
        return this.props.createAttachment;
      }
    }
  };

  addAttachment = async newAttachments => {
    const {
      value,
      parentType,
      isUserStudent,
      isAutoLockingEnabled,
      parentId,
      isLockingEnabled,
      isAutoSimilarityCheckEnabled,
    } = this.props;

    this.setState({ showFullScreenLoader: true });
    const mutationForCreateAttachment = this.getMutationForCreateAttachment();

    newAttachments = await Promise.all(
      _.map(newAttachments, attachment => {
        return mutationForCreateAttachment({
          attachment,
          nodeId: parentId,
          parentType,
          type: parentType,
          lockingState:
            isLockingEnabled && isAutoLockingEnabled
              ? isUserStudent
                ? {
                    state: ENTITY_TO_BE_LOCKED_STATE,
                    scheduledAt: moment().add(ENTITY_LOCKING_MINUTES, "m"),
                  }
                : {
                    state: ENTITY_LOCKED_STATE,
                    scheduledAt: moment(),
                  }
              : undefined,
        });
      })
    );

    newAttachments = _.map(newAttachments, attachments => _.last(attachments));
    // filter new attachments for falsy values
    newAttachments = _.filter(newAttachments, attachment => attachment?.id);

    this.updateValue([...(value ? value : []), ...newAttachments], {
      parentType,
      parentId,
    });

    if (isAutoSimilarityCheckEnabled) {
      _.forEach(newAttachments, attachment => {
        if (attachment?.id) {
          setTimeout(() => {
            this.autoCheckSimilarityRef?.current?.onAutoCheckForSimilarity({
              attachmentId: attachment.id,
            });
          });
        }
      });
    }

    this.setState({
      showFullScreenLoader: false,
    });
  };

  createDropdownComponent = () => {
    const {
      buttonLabel,
      buttonIconType,
      t,
      accept,
      excludeFileExtensionsList,
      defaultExportType,
      attachmentExportOptions,
      multiselect,
      buttonDropDownContainerStyle,
      buttonParentStyle,
      dropDownOptions,
      canAddMaximumAttachments,
      uploadingResources,
      maxSize,
      parentId,
      parentType,
      dropdownType,
      testId,
      dsVersion,
    } = this.props;
    const Icon = ICONS[buttonIconType];
    const isDSV2 = dsVersion === "2.0";

    const label = buttonLabel
      ? buttonLabel
      : t("common:add_a_with_label", { label: t("common:file") });

    const updatedDropdownOptions = _.map(dropDownOptions, option => {
      return {
        ...option,
        icon: ICONS_MAP[option.icon],
      };
    });

    const commonCreateDropDownProps = {
      multiselect,
      buttonDropDownContainerStyle,
      attachmentExportOptions,
      accept,
      defaultExportType,
      parentId,
      parentType,
      shouldCallMutation: true,
      onMultipleFilesUploaded: this.addAttachment,
      dropDownOptions: updatedDropdownOptions,
      canAddMaximumAttachments,
      showLocalAttachmentsInViewMode: true,
      buttonParentStyle,
      maxSize,
      buttonDropdownParentContainerStyle:
        styles.buttonDropdownParentContainerStyle,
      excludeFileExtensionsList,
      isNewDropdown: isDSV2,
    };

    switch (dropdownType) {
      case "AudioRecorderWithUpload": {
        return (
          <CreateDropDownWithAudioRecorder
            commonCreateDropDownProps={commonCreateDropDownProps}
            {...this.props}
            label={label}
            handleAudioAttachment={this.handleAudioAttachment}
            updateInputFieldLocally={this.updateInputFieldLocally}
            testId={testId}
          />
        );
      }

      default: {
        return (
          <CreateDropDown
            buttonComponent={
              <Button
                icon={<Icon />}
                _legacy_variant="outlined-subtle"
                type="outlined"
                variant="neutral"
                disabled={!_.isEmpty(uploadingResources)}
                testId={`${testId}-addAttachment`}
              >
                {label}
              </Button>
            }
            disabled={!_.isEmpty(uploadingResources)}
            {...commonCreateDropDownProps}
            dsVersion="2.0"
            testId={testId}
          />
        );
      }
    }
  };

  renderEdit = () => {
    const {
      value,
      mode,
      dropDownOptions,
      attachmentContainerStyle,
      cardBackgroundColor,
      cardType,
      horizontalCardStyle,
      buttonParentStyle,
      disabled,
      canAddMaximumAttachments,
      projectGroupType,
      projectId,
      showSimilarity,
      projectGroupId,
      t,
      deleteEntityLabel,
      isAnnotationEnabled,
      showSingleAttachment,
      name,
      updateSelectedTemplate,
      fieldKey,
      isLockingEnabled,
      isUserStudent,
      submissionContainerStyle,
      parentId,
      parentType,
      showNotificationsDot,
      showWaveformPlayer,
      sourceFrom,
      testId,
      dsVersion,
      showCurrentTime,
    } = this.props;

    const isDSV2 = dsVersion === "2.0";

    const { showMoreAttachments, showFullScreenLoader } = this.state;

    const defaultHorizontalCardStyle = horizontalCardStyle
      ? horizontalCardStyle
      : {
          ...styles.horizontalCardStyle,
          ...(isDSV2 ? styles.horizontalCardStyleV2 : {}),
        };

    const cardStyles = cardBackgroundColor
      ? {
          ...defaultHorizontalCardStyle,
          backgroundColor: colors[cardBackgroundColor],
        }
      : defaultHorizontalCardStyle;

    const getOtherProps = () => {
      let otherProps = {};

      if (updateSelectedTemplate) {
        otherProps = {
          onClickAttachmentCard: attachment =>
            updateSelectedTemplate({
              attachment,
              annotationConfig: {
                isAnnotationEnabled:
                  isAnnotationEnabled &&
                  !disabled &&
                  !(isAttachmentLocked({ attachment }) && isUserStudent) &&
                  !_.includes(attachment?.id, "NEW_"),
                showSimilarity,
                fieldKey,
              },
            }),
        };
      }
      return otherProps;
    };

    const attachmentBottomComponent = params => {
      const {
        attachment,
        recheckButtonHoverClass,
        showSimilarityOnHeader = false,
      } = params;
      return !_.isEmpty(attachment) ? (
        <SimilarityIndexComponent
          metadata={{
            entityId: projectId,
            entityType: "PROJECT",
          }}
          attachment={attachment}
          recheckButtonHoverClass={recheckButtonHoverClass}
          showSimilarityOnHeader={showSimilarityOnHeader}
          projectGroupType={projectGroupType}
          projectGroupId={projectGroupId}
          customRef={this.autoCheckSimilarityRef}
          sourceFrom={sourceFrom}
          testId={testId}
        />
      ) : null;
    };

    const setShowSingleAttachment = () => {
      this.setState({
        showMoreAttachments: !showMoreAttachments,
      });
    };

    const seeMoreTextStyles = classNames({
      "text-label-2": true,
      [classes.seeMoreText]: true,
    });

    const containerClasses = classNames(classes.container, {
      [classes.containerV2]: isDSV2,
    });

    const updatedDropdownOptions = _.map(dropDownOptions, option => {
      return {
        ...option,
        icon: ICONS_MAP[option.icon],
      };
    });

    return (
      <>
        <div className={containerClasses} style={submissionContainerStyle}>
          {!_.isEmpty(value) || disabled ? (
            <AttachmentList
              value={
                !_.isEmpty(value)
                  ? showMoreAttachments
                    ? [_.head(value)]
                    : value
                  : []
              }
              name={name}
              deleteEntityLabel={deleteEntityLabel || t("common:file")}
              mode={mode}
              parentId={parentId}
              parentType={parentType}
              updateInputField={this.updateInputFieldLocally}
              showLocalAttachmentsInViewMode={true}
              showCreateDropdown={false}
              shouldCallMutation={true}
              showNotificationsDot={showNotificationsDot}
              dropDownOptions={updatedDropdownOptions}
              attachmentContainerStyle={{
                ...styles.attachmentContainerStyle,
                ...(isDSV2 ? styles.attachmentContainerStyleV2 : {}),
                ...attachmentContainerStyle,
              }}
              horizontalCardStyle={cardStyles}
              cardType={cardType}
              buttonParentStyle={buttonParentStyle}
              disabled={disabled}
              emptyComponent={<NotAddedEmptyView dsVersion={dsVersion} />}
              attachmentBottomComponent={
                showSimilarity ? attachmentBottomComponent : null
              }
              isLockingEnabled={isLockingEnabled}
              {...getOtherProps()}
              showWaveformPlayer={showWaveformPlayer}
              sourceFrom={sourceFrom}
              dsVersion="2.0"
              testId={testId}
              shouldUpdateInputOnRename={true}
              showAudioCurrentTime={showCurrentTime}
            />
          ) : null}
          {showSingleAttachment && _.size(value) > 1 && (
            <div
              className={seeMoreTextStyles}
              onClick={setShowSingleAttachment}
            >
              {showMoreAttachments
                ? t("project:number_more_files", {
                    count: _.size(value) - 1,
                  })
                : t("common:see_less_noDots")}
            </div>
          )}

          {!disabled &&
            (!canAddMaximumAttachments ||
              canAddMaximumAttachments > _.size(value)) &&
            this.createDropdownComponent()}
        </div>

        {showFullScreenLoader && <FullScreenLoader />}
      </>
    );
  };
}

SubmissionItem.defaultProps = {
  ...UIBaseComponent.defaultProps,
  dropDownOptions: DROP_DOWN_OPTIONS,
  buttonIconType: "AddOutlined",
  accept: [
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/vnd.google-apps.document",
    "application/pdf",
    "text/rtf",
    "application/rtf",
    "application/vnd.oasis.opendocument.text",
  ],
  defaultExportType: "LINK",
  attachmentExportOptions: ["LINK", "FILE"],
  multiselect: false,
  cardType: "design-media-card",
  attachmentContainerStyle: {},
  buttonDropDownContainerStyle: {
    top: "44px",
  },
  buttonParentStyle: {},
  canAddMaximumAttachments: null,
  showSimilarity: false,
  isAnnotationEnabled: false,
  showSingleAttachment: false,
  maxSize: 52428800,
  isLockingEnabled: false,
  submissionContainerStyle: {},
  showNotificationsDot: true,
  showWaveformPlayer: false,
  showCurrentTime: false,
};

const mapActionCreators = {
  createAttachmentForProjects,
  createAttachment,
};

const getUploadingResources = ({ parentId, parentType, progressOfUploads }) => {
  const keys = Object.keys(progressOfUploads);
  const uploadingResources = [];

  _.forEach(keys, key => {
    const resource = progressOfUploads[key];

    if (resource.parentType == parentType && resource.parentId == parentId) {
      uploadingResources.push({
        id: resource.id,
        progress: resource.progress,
        cancelToken: resource.cancelToken,
        ..._.get(resource, "attachment", {}),
      });
    }
  });

  return uploadingResources;
};

const mapStateToProps = (state, ownProps) => {
  const projectGroupDetails = getCurrentProjectGroupDetails({ state });
  const {
    type: projectGroupType,
    id: projectGroupId,
    subType: projectGroupSubType,
  } = projectGroupDetails;

  const userInfo = getUserInfo();
  const showSimilarity = _.get(ownProps, "showSimilarity", false);
  const progressOfUploads = state.app_services.progressOfUploads;

  const userType = getUserType(state);

  const isUserStudent = _.isEqual(userType, STUDENT);

  const userId = _.get(userInfo, "id", "");
  const userEntityType = _.get(userInfo, "userEntityType", "");
  const parentType = _.get(ownProps, "parentType", "")
    ? _.get(ownProps, "parentType", "")
    : "FIELD";
  const parentId = _.get(ownProps, "parentId", "")
    ? _.get(ownProps, "parentId", "")
    : _.get(ownProps, "fieldId", "");

  const currentCurriculumProgramType = _.get(
    state,
    "platform.currentCurriculumProgram.type",
    CURRICULUM_TYPE_DP
  );

  const currentCurriculumProgramId = _.get(
    state,
    "platform.currentCurriculumProgram.id",
    null
  );
  const organizationId = _.get(userInfo, "org_id", "");

  const isAutoSimilarityCheckEnabled = showSimilarity
    ? getSettingValue({
        name: getAutoCheckSimilaritySettingName({
          projectGroupSubType,
          curriculumProgramType: currentCurriculumProgramType,
        }),
        organizationId,
        userEntityType,
        userId,
        currentCurriculumProgramId,
      })
    : false;

  return {
    projectId: _.get(ownProps, "params.projectId", null),
    projectGroupType,
    projectGroupId,
    uploadingResources: getUploadingResources({
      parentType,
      parentId,
      progressOfUploads,
    }),
    isUserStudent,
    userId,
    userEntityType,
    parentType,
    parentId,
    isAutoSimilarityCheckEnabled,
  };
};

export default compose(
  I18nHOC({ resource: ["common"] }),
  withRouter,
  connect(mapStateToProps, mapActionCreators)
)(SubmissionItem);
